import { SMS_CONSENT_TEXT, CONSENT_VERSION } from '../components/ui/SmsConsentCheckbox';

/** The React contact and SMS forms submit to a same-origin, PHP consent-record endpoint. */
export const FORM_POST_URL = "/api/submit.php";

/** Frontend disclosure snapshot, submitted alongside each request. */
export function consentRecord({ smsCustomerCare = false, smsMarketing = false } = {}) {
  const care = Boolean(smsCustomerCare);
  const marketing = Boolean(smsMarketing);
  return {
    sms_customer_care_status: care ? 'YES - checked' : 'NO - unchecked',
    sms_marketing_status: marketing ? 'YES - checked' : 'NO - unchecked',
    sms_consent_status: care || marketing ? 'YES' : 'NO',
    consent_version: CONSENT_VERSION,
    customer_care_disclosure_accepted: care ? SMS_CONSENT_TEXT.customerCare : 'Not selected',
    marketing_disclosure_accepted: marketing ? SMS_CONSENT_TEXT.marketing : 'Not selected',
  };
}

export function formatPhone(value) {
  const d = (value || '').replace(/\D/g, '').slice(0, 11);
  const n = d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
  if (n.length <= 3) return n;
  if (n.length <= 6) return `(${n.slice(0, 3)}) ${n.slice(3)}`;
  return `(${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6, 10)}`;
}

export function phoneDigits(value) {
  const d = (value || '').replace(/\D/g, '');
  return d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
}
